import ButtonLink from '@components/common/Button/ButtonLink'
import ProgressBar from '@components/common/ProgressBar/ProgressBar'
import HeaderBack from '@/components/dashboard/Header/HeaderBack'
import MotionText from '@/components/common/Motion/MotionText'

import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useTranslation, Trans } from 'react-i18next'
import { useEffect } from 'react'
import { useKycStore } from '@store/useKycStore'
import { usePageSetup } from '@/hooks/usePageSetup'

export const KycVehicleHowPage = () => {
  const { t } = useTranslation()
  usePageSetup(t('kyc.pageTitle.vehicleHow'), { scroll: true })

  const progress = useKycStore((state) => state.progress)
  const setProgress = useKycStore((state) => state.setProgress)

  useEffect(() => setProgress(4), [])

  return (
    <div className="h-full bg-white p-5 pb-8 flex flex-col">
      <HeaderBack className='items-center gap-4'>
        <ProgressBar
          currentStep={progress}
          totalSteps={8}
        />
      </HeaderBack>

      <div className="flex-1 flex flex-col mt-4">
        <div className="space-y-4">
          <MotionText
            as="h2"
            className="text-zinc-900 text-3xl font-bold leading-tight"
            delay={0.2}
          >
            {t('kyc.vehicleHow.title')}
          </MotionText>
          <MotionText
            as="p"
            className="text-zinc-700 text-base"
            delay={0.4}
          >
            <Trans i18nKey="kyc.vehicleHow.requiredForm" components={{ strong: <strong /> }} />
          </MotionText>
          <MotionText
            as="p"
            className="text-zinc-700 text-base"
            delay={0.6}
          >
            {t('kyc.vehicleHow.moreInfo')}
            <Link
              to="https://deklaravimas.vmi.lt/lt/Korteles/Naujienos_kortele/Naujienos_kortele.aspx?newsitemid=c2996fdc-2a95-4a5c-8a23-82467acf4f71"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-blue-600"
            >
              {t('kyc.vehicleHow.moreInfoLink')}
            </Link>
          </MotionText>
          <MotionText
            as="p"
            className="text-zinc-700 text-base"
            delay={0.8}
          >
            {t('kyc.vehicleHow.retroactive')}
          </MotionText>
        </div>
      </div>

      <div className="space-y-4 flex flex-col">
        <ButtonLink variant='secondary' to={'/kyc/vat'}>
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.2,
              ease: "easeOut"
            }}
          >
            {t('kyc.vehicleHow.vehicleRegistered')}
          </motion.span>
        </ButtonLink>
      </div>
    </div>
  )
}

export default KycVehicleHowPage